import React from "react";

import { CHIP_TONES } from "./SheetChip";

/**
 * A chip that says one thing in a word or two (In progress, Locked,
 * Location on) and, tapped, shows the rest just under the chips
 * (ChipDetails); the caller keeps which one is open. `title` says it to a
 * mouse too.
 */
export const InfoChip = ({
  tone = "neutral",
  icon: Icon,
  label,
  open = false,
  onToggle,
  panelId,
  title,
}) => (
  <button
    type="button"
    aria-expanded={open}
    aria-controls={open ? panelId : undefined}
    onClick={onToggle}
    title={title}
    className={`inline-flex shrink-0 cursor-pointer items-center gap-[4px] whitespace-nowrap rounded-[4px] border-[1px] px-[6px] py-[2px] text-[10.5px] font-semibold leading-[1.4] [@media(pointer:coarse)]:min-h-[30px] [@media(pointer:coarse)]:px-[9px] [@media(pointer:coarse)]:text-[12px] ${CHIP_TONES[tone] ?? CHIP_TONES.neutral} ${open ? "shadow-[inset_0_-2px_0_currentColor]" : ""}`}
  >
    {Icon && <Icon aria-hidden="true" className="h-[12px] w-[12px] shrink-0" />}
    {label}
  </button>
);

// The rest of what the open InfoChip says, in its tone, on a row of its own.
export const ChipDetails = ({ id, label, tone = "neutral", children }) => (
  <div
    id={id}
    role="region"
    aria-label={label}
    className={`basis-full rounded-[6px] border-[1px] px-[10px] py-[7px] text-[12px] leading-[1.45] ${CHIP_TONES[tone] ?? CHIP_TONES.neutral}`}
  >
    {children}
  </div>
);
